import './App.css';
import Homepage from './pages/Homepage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './pages/Aboutus';       // Make sure the path is correct
import Contact from './pages/Contact';   // Make sure the path is correct
import PrivacyandPolicy from './pages/PrivacyandPolicy';
import TermsandConditions from './pages/TermsandConditions';
import RefundPolicy from './pages/RefundPolicy';
import { ProductPage } from './pages/ProductPage';

function App() {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy-and-policy" element={<PrivacyandPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsandConditions />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/product" element={<ProductPage />} />
    </Routes>
  </Router>  );
}

export default App;
